var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3949 21.8722C28.2218 21.3853 27.9024 20.9637 27.4804 20.6653C27.0585 20.3669 26.5546 20.2061 26.0378 20.2051H24.1028C23.5508 20.2022 23.0173 20.4041 22.6055 20.7717C22.1937 21.1394 21.9328 21.6467 21.8734 22.1956C21.8139 22.7444 21.9601 23.2958 22.2836 23.7431C22.6072 24.1904 23.0851 24.5018 23.6249 24.6172L26.5714 25.2601C27.1738 25.392 27.7063 25.7418 28.0665 26.2425C28.4267 26.7431 28.5892 27.3592 28.5227 27.9723C28.4563 28.5855 28.1656 29.1525 27.7065 29.5643C27.2475 29.9762 26.6524 30.2039 26.0357 30.2036H24.3707C23.2821 30.2036 22.3564 29.5093 22.0135 28.5386M25.2042 20.2051V17.7043M25.2042 32.7043V30.2058M14.7814 39.4243V34.0672H20.1385",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1886 22.9372C39.7574 25.9698 39.3033 29.1054 37.8973 31.852C36.4914 34.5985 34.2132 36.8005 31.4205 38.1123C28.6277 39.4241 25.4784 39.7714 22.4669 39.0998C19.4554 38.4282 16.7522 36.7756 14.7814 34.4015M11.8114 28.0629C11.2426 25.0303 11.6967 21.8946 13.1027 19.1481C14.5086 16.4015 16.7868 14.1996 19.5795 12.8878C22.3723 11.576 25.5216 11.2287 28.5331 11.9003C31.5446 12.5719 34.2478 14.2245 36.2186 16.5986",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2186 11.5758V16.9329H30.8615",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipIcon);
export default __webpack_public_path__ + "static/media/membershipIcon.31da34d88c8f337a0bf7eb79f8715e43.svg";
export { ForwardRef as ReactComponent };